import React from "react";
import './SelectionButton.css';

export const SelectionButton = ({ name, icon, isSelected, onClick, disabled = false }) => {
    return (
        <button
            key={name}
            className={`selection-button ${disabled ? 'disabled' : ''} ${isSelected ? 'selected' : ''}`}
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
        >
            <img src={icon} className="icon" alt={name} />
            <p>{name}</p>
        </button>
    );
};
